import { tz as tzFn } from '@date-fns/tz';
import type { Nullable } from '@iheartjane/types';
import { format } from 'date-fns';

import type {
  TimeRange,
  WeeklyWorkingHours,
} from '@jane/bloom/types/schemas/roots/bloom/schedule';

import { timezone } from './timezone';

export function timeRangeForToday(
  weeklyHours: Nullable<WeeklyWorkingHours>,
  tz: string,
  now: Date = new Date()
): Nullable<TimeRange> {
  try {
    /** The weekday name at the *given* time zone, not the local zone  */
    const dayToday = format(now, 'eeee', {
      in: tzFn(timezone(tz)),
    }).toLowerCase();
    const todayHours = weeklyHours?.find((h) => h.day === dayToday);

    if (todayHours?.period.from && todayHours.period.to) {
      /** returning a new object to accommodate typescript's limited type-narrowing */
      return {
        from: todayHours.period.from,
        to: todayHours.period.to,
      };
    } else {
      return null;
    }
  } catch {
    return null;
  }
}
